import React from 'react';

import { IconV2, TextV2, Box, Flex, LinkV2 } from '@withjoy/joykit';
import { IconError } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';

// TODO: need guidance from server: https://withjoy.atlassian.net/browse/PRNT-157
const COURIER_PAGE_URL = '';

export const InlineMessage: React.FC = () => {
  const { t2 } = useTranslation('stationery');
  const courierErrorMessage = t2('cardCustomizer', 'courierErrorMessage');

  return (
    <Box border="1px solid #FFD8BB" borderRadius="8px" padding="24px" marginX={['24px', 0]}>
      <Flex width="100%" columnGap="24px">
        <IconV2 size="lg">
          <IconError color="#E0946D" />
        </IconV2>
        <TextV2 textAlign="initial" typographyVariant="body1">
          {courierErrorMessage.text1}{' '}
          <LinkV2
            _activeLink={{ color: 'mono14' }}
            _visited={{ color: 'mono14' }}
            _active={{ color: 'mono14' }}
            _pressed={{ color: 'mono14' }}
            _hover={{ color: 'mono14' }}
            color="mono5"
            fontSize="15px"
            href={COURIER_PAGE_URL}
            isExternal
          >
            {courierErrorMessage.link}
          </LinkV2>{' '}
          {courierErrorMessage.text2}
        </TextV2>
      </Flex>
    </Box>
  );
};
